var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMindfulness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 148,
    viewBox: "0 0 267 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 106C143.51 106 165 84.5097 165 58C165 31.4903 143.51 10 117 10C90.4903 10 69 31.4903 69 58C69 84.5097 90.4903 106 117 106Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121 138C149.719 138 173 114.719 173 86C173 57.2812 149.719 34 121 34C92.2812 34 69 57.2812 69 86C69 114.719 92.2812 138 121 138Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149 148C177.719 148 201 124.719 201 96C201 67.2812 177.719 44 149 44C120.281 44 97 67.2812 97 96C97 124.719 120.281 148 149 148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165 127C193.719 127 217 103.719 217 75C217 46.2812 193.719 23 165 23C136.281 23 113 46.2812 113 75C113 103.719 136.281 127 165 127Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152 100C178.51 100 200 78.5097 200 52C200 25.4903 178.51 4 152 4C125.49 4 104 25.4903 104 52C104 78.5097 125.49 100 152 100Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 65,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 62,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 2,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.5,
    cy: 139.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 136.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 52,
    r: 24,
    fill: "#F9D5E9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 65,
    r: 24,
    fill: "#F9D5E9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 96,
    r: 24,
    fill: "#F9D5E9"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 69,
    r: 24,
    fill: "#F9D5E9"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 94,
    r: 24,
    fill: "#F9D5E9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 74,
    r: 16,
    fill: "#F3BB40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15.5L51 23.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 22.5L242.5 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 106.5L45.5 99",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233 104.5L253 110.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindfulness);
export default __webpack_public_path__ + "static/media/mindfulness.c755363f3bf21b1ecf65fb0c0bd1030f.svg";
export { ForwardRef as ReactComponent };